export * as authApis from './auth.apis';
export * as usersApis from './users.apis';
export * as enrollmentsApis from './enrollments.apis';
export * as meetingsApis from './meetings.apis';
export * as knowledgeBaseApis from './knowledgeBase.apis';
export * as homeworksApis from './homeworks.apis';
export * as coursesApis from './courses.apis';
export * as userManagementApis from './userManagement.apis';
export * as parentApis from './parent.apis';
export * as mentorApis from './mentor.apis';
export * as customerSuccessApis from './customerSuccess.apis';
export * as npsApis from './nps.apis';
export * as reportApis from './report.apis';
export * as adminMetricsApis from './adminMetrics.apis';
export * as extraServicesApis from './extraServices.apis';
export * as lmsApis from './lms.apis';
export * as flagApis from './flag.apis';
export * as majorApis from './major.apis';
export * as healthApis from './health.apis';
export * as knowledgeBaseChatApis from './knowledgeBaseChat.apis';
export * as videoApis from './video.apis';
export * as universityApis from './university.apis';
export * as examApis from './exam.apis';
export * as cityApis from './city.apis';
export * as k12SchoolApis from './k12School.apis';
export * as churnApis from './churn.apis';
export * as contractsApis from './contracts.apis';
export * as emailLogApis from './emailLog.apis';
export * as integrationsApis from './integrations.apis';
export * as systemHealthApis from './systemHealth.apis';
export * as studentInsightsApis from './studentInsights.apis';
export * as meetingIssuesApis from './meetingIssues.apis';
export * as auditLogApis from './auditLog.apis';
